<template>
    <div class="page main-signin-wrapper">
        <div class="row signpages text-center">
            <div class="col-md-12">
                <div class="redirect-description-box">
                    <img src="/assets/img/loading.gif">
                    <p>در حال انتقال ...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    created(){
        localStorage.setItem('agc-token',this.$route.params.token);
        setTimeout(() => {
            window.location.href = '/';
        },2500);
    }
}
</script>

<style scoped>
.redirect-description-box{
    display: block;
    position: relative;
    background: #fff;
    border-radius: 10px;
    width: 70%;
    right: 15%;
    box-shadow: 0 5px 5px rgba(0,0,0,0.1);
}
.redirect-description-box img{
    display: inline-block;
    height: 100px;
}
.redirect-description-box p{
    display: inline-block;
    margin-bottom: 0 !important;
    position: relative;
    top: 3px;
}
</style>